<script setup>
// `lang`/`dir` de l'<html>, canonical i alternates hreflang de cada ruta. Sense
// això Google veu /mission, /ca/missio i /es/mision com a pàgines soltes que
// competeixen entre elles en comptes de tres versions de la mateixa.
useHead(useLocaleHead())

useHead({
  titleTemplate: (title) => title ? `${title} · Puigdellívol` : 'Puigdellívol · Fusteria Barcelona',
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'Puigdellívol',
        description: "Fabricació i col·locació de mobiliari i complements de fusta a mida per a exposicions, museus, fires, escenaris, decoradors i constructors. Empresa familiar des de 1736.",
        url: 'https://puigdellivol.com',
        image: 'https://puigdellivol.com/img/puigdellivol.png',
        telephone: '+34938772939',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Ctra. C16-C km 1,8, P.I. Sant Isidre I',
          addressLocality: 'Sant Fruitós de Bages',
          postalCode: '08272',
          addressRegion: 'Barcelona',
          addressCountry: 'ES',
        },
        sameAs: [
          'https://www.facebook.com/PuigdellivolSL',
          'https://www.instagram.com/puigdellivol_wood',
          'https://es.pinterest.com/puigdellivol_wood/',
        ],
      }),
    },
  ],
})

useSeoMeta({
  ogSiteName: 'Puigdellívol',
  ogType: 'website',
  ogImage: 'https://puigdellivol.com/img/puigdellivol.png',
  twitterCard: 'summary_large_image',
})
</script>

<template>
  <div class="relative">
    <NuxtPage />
  </div>
</template>